import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import TeamCell from "@/components/headToHead/TeamStats/TeamCell";
import { createTableData } from "./utils";
import type {
  GetHeadToHeadTeamStatsTabQuery,
  BasicTeam,
} from "@/graphql/gql/graphql";
import type { CellContext } from "@tanstack/react-table";

type Data = {
  team: Pick<BasicTeam, "abbreviation" | "logoSVG">;
  offense_value: number;
  passing_value: number;
  rushing_value: number;
  defense_value: number;
  pass_defense_value: number;
  rush_defense_value: number;
};

const renderTeamCell = (row: CellContext<Data, BasicTeam>) => (
  <TeamCell
    abbreviation={row.getValue().abbreviation}
    logoSVG={row.getValue().logoSVG}
  />
);

const createColumns = () => {
  const columnHelper = createColumnHelper<Data>();

  return [
    columnHelper.group({
      id: "team",
      header: "",
      columns: [
        columnHelper.accessor("team", {
          header: "Team",
          cell: renderTeamCell,
        }),
      ],
    }),
    columnHelper.group({
      id: "stats",
      header: "Stats",
      columns: [
        columnHelper.accessor("offense_value", {
          header: "Offense",
        }),
        columnHelper.accessor("passing_value", {
          header: "Pass",
        }),
        columnHelper.accessor("rushing_value", {
          header: "Rush",
        }),
        columnHelper.accessor("defense_value", {
          header: "Defense",
        }),
        columnHelper.accessor("pass_defense_value", {
          header: "Pass Defense",
        }),
        columnHelper.accessor("rush_defense_value", {
          header: "Rush Defense",
        }),
      ],
    }),
  ];
};

const useTeamEfficiencyTable = (
  data: GetHeadToHeadTeamStatsTabQuery["event"]
) => {
  const tableData = createTableData(data);
  const columns = useMemo(createColumns, []);

  return {
    columns,
    tableData,
  };
};

export default useTeamEfficiencyTable;
